module.exports = __webpack_public_path__ + "static/header-b61805c54631a8e2d9454ccdc70a6614.jpg";